import React, {Component} from 'react';
import axios from 'axios';

export default class Logout extends Component {
	constructor(props) {
        super(props);
        if(localStorage.getItem('token') != '' && localStorage.getItem('token') != null && localStorage.getItem('token') != undefined)
		{
            localStorage.removeItem('token');
            localStorage.removeItem('userid');
            localStorage.removeItem('dept_code');
            localStorage.removeItem('firstname');
            localStorage.removeItem('lastname');
            localStorage.removeItem('email');
            //localStorage.setItem('menuText',[]);
            delete axios.defaults.headers.common['Authorization'];
            this.setState({
                redirectToReferrer:''
            });
            console.log("logout successfully",localStorage.getItem('token'));
            window.location.reload();
        }
        else
        {
            return window.location.href="/login";
        }        
    }
}
